import ELID from 'constants/elid.const';
import appendDomElement from 'utils/dom/elementAppend.util';
import removeDomElement from 'utils/dom/removeDomElement.util';
import logger from 'utils/logger.util';

const L = logger('HtmlPopup');

const generateHtml = ({ title, content }) => `
  <div class='overlay' />
  <div class='confirmation-modal animated zoomIn'>
    <div class='modal-body'>
      <h2 class='modal-title'>${title}</h2>
      <div class='modal-content'>
        ${content}
      </div>
      <div class='modal-footer'>
        <button
          class='btn btn-violet-link'
          onclick="window.HtmlPopup(false, { content: '', title: '' });"
        >OK
        </button>
      </div>
    </div>
  </div>
`;

// FIXME: use { show, title, content } as props and possible convert to proper React component
const HtmlPopup = (show, { content, title }) => {
  // FIXME: what is the use of this global?
  window.HtmlPopup = HtmlPopup;

  const element = document.getElementById(ELID.closepop);
  if (!show) {
    return removeDomElement({ element });
  }

  if (element) {
    return L.warn('()', 'Already existing element:', element);
  }

  const parent = document.getElementById(ELID.schedscroll);
  if (!parent) {
    return void L.warn('()', 'No parent:', parent);
  }

  const child = document.createElement('div');
  child.id = ELID.closepop;
  child.innerHTML = generateHtml({ title, content });

  return appendDomElement({ parent, child });
};

export default HtmlPopup;
